import 'katex/dist/katex.min.css';
import { htmlAvecKatex } from './htmlAvecKatex';
import { fractionsEnProse } from '../../utils/fractionsProse';

/**
 * Rendu d'une chaîne HTML en alternant texte HTML sanitizé et fragments KaTeX inline `$\…$`.
 *
 * Même logique que `renderHtmlWithKatex` de RichTextBlockEleve (énoncé) — extraite ici
 * pour être réutilisée par les consignes du programme de construction.
 * (À dédupliquer après la démo : faire pointer RichTextBlockEleve sur ce composant.)
 *
 * Regex stricte : le `$` d'ouverture doit être suivi d'un `\` (début de commande LaTeX)
 * → pas de faux positif sur `$50`, `$abc$`, etc.
 *
 * @param {string} html - HTML pouvant contenir des `$\…$`
 * @param {string} [className] - classes portées par le span racine
 */
const HtmlKatex = ({ html: htmlBrut, className = '' }) => (
    // Consigne : fraction seule en style texte, calcul intact
    // (utils/fractionsProse.js), puis rendu en UNE chaîne (htmlAvecKatex.js) :
    // le paragraphe n'est jamais coupé autour d'une formule.
    <span
        className={`[&_.katex]:text-inherit ${className}`}
        dangerouslySetInnerHTML={{ __html: htmlAvecKatex(fractionsEnProse(htmlBrut)) }}
    />
);

export default HtmlKatex;
